import React, {useEffect} from 'react';
import {useStoreState, useStoreActions} from "~/store";
import {useLocation} from "react-router";
import FlashMessage from "~/app/common/FlashMessage";
import { SyncProgressBanner } from '~/data/sync/SyncProgressUi';
import Offline from "./Offline";
import IssueMessage from "./Issue";

import classes from './style.module.scss';

export type MessagesComponent = React.FC

const Messages: MessagesComponent = () => {
    const messages = useStoreState(state => state.app.flashMessage.messages);
    const setFlashMessages = useStoreActions(actions => actions.app.flashMessage.setMessages);
    const location = useLocation();

    useEffect(() => {
        setFlashMessages([]);
    }, [location, setFlashMessages]);

    return (
        <div className={classes.stack}>
            <SyncProgressBanner />
            <Offline/>
            <IssueMessage/>
            {messages && messages.map((message, index) => <FlashMessage {...message} key={index}/>)}
        </div>
    )
};

export default Messages
